<ng-container>
    <div dropdown placement="bottom left" container="body" *xviIfHasAnyOfPermission="['VenuesInventory.TransferGroupTemplate.View']">
      <i
        id="button-custom-html"
        dropdownToggle
        class="glyphicon glyphicon-option-vertical three-dots-icon"
        aria-controls="dropdown-alignment"
      ></i>
      <ul
        id="dropdown-menu-dividers"
        *dropdownMenu="'.ag-body-viewport'"
        class="xux-grid-actions dropdown-menu actions-menu"
        role="menu"
        aria-labelledby="button-menu-dividers"
      >
        <actions-button-renderer
          [status]="data.status"
          [buttons]="actionButtons"
          (onActionBtnClicked)="emitAction($event)">
        </actions-button-renderer>
      </ul>
    </div>
  </ng-container>